import React, { useState, useEffect } from 'react';
import Header from '../../components/Header';
import api from '../../services/api-integracao-os';
import styleslistformularios from "./listformularios-styles.module.css";
import swalstyles from "./swal-styles.module.css";
import loadingstyles from "./loading-styles.module.css";
import { useHistory } from "react-router-dom";
import moment from 'moment';
import Swal from 'sweetalert2';
import Select, { components } from 'react-select'

import { FaTrashAlt } from 'react-icons/fa';

export default function IntegracaoOs() {
    const [loading, setLoading] = useState(true);

    const [listFormularios, setListFormularios] = useState([]);

    let history = useHistory();

    useEffect(() => {
        if(loading) {
            if(!history.location.state || (history.location.state && !history.location.state.hasAccess)) {
                history.push('/integracaoos');
            } else {
                api.get(`/formulario/getallformularios?id_empresa=${parseInt(localStorage.empresa_id)}`).then(response => {
                    if (response.data.error) {
                        console.log(response.data.error);
                        Swal.fire({
                            customClass: {
                                container: swalstyles.swalcontainer,
                                popup: swalstyles.swalbackground
                            },
                            title: 'OCORREU UM ERRO INESPERADO!',
                            text: 'POR FAVOR, CONTATE UM ADMINISTRADOR DO SISTEMA',
                            icon: 'error',
                        }).then(() => {
                            history.push('/integracaoos');
                        });
                    } else if(response.data.result) {
                        setListFormularios(response.data.result.formularios);
                    }
                }).catch(err => {
                    // handle error
                    console.log(err);
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'NÃO FOI POSSÍVEL CONCLUIR A REQUISIÇÃO!',
                        text: 'POR FAVOR, TENTE NOVAMENTE MAIS TARDE',
                        icon: 'error',
                    }).then(() => {
                        history.push('/integracaoos');
                    });
                }).finally(() => {
                    setLoading(false);
                });
            }
        }
    }, []);

    function Theme(theme) {
        return ({
            ...theme,
            colors: {
                ...theme.colors,
                primary: '#d4d4d4', // CHOOSED
                primary50: '#e7e7e7', // CLICK
                primary25: '#f3f3f3', // HOVER
            }
        })
    }

    function Option(props) {
         if(['select_'].includes(props.selectProps.inputId)) {
            return (
                <components.Option {...props}>
                    <div style={{textAlign: 'left', fontWeight: 500}}>
                        <div>{props.data.codigo} - {props.data.descricao}</div>
                    </div>
                </components.Option>
            )
        }
    }

    function FilterOptions(candidate, input) {
        return (`${candidate.data.codigo} - ${candidate.data.descricao}`).toLowerCase().includes(input.toLowerCase());
    }

    function removeMask(value) {
        return value.replace(/[^0-9]/g, '');
    }

    function maskCpfCnpj(value) {
        const newValue = value.replace(/[^0-9]/g, '');

        const regex = (newValue.length < 11) ? /^(\d)/ : (newValue.length < 12) ? /^(\d{3})(\d{3})(\d{3})(\d{2})/ : (newValue.length < 13) ? /^(\d{2})(\d{3})(\d{3})(\d{4})/ : /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/;
        const regexText = (newValue.length < 11) ? '$1' : (newValue.length < 12) ? '$1.$2.$3-$4' : (newValue.length < 13) ? '$1.$2.$3/$4' : '$1.$2.$3/$4-$5';

        return newValue.replace(regex, regexText);
    }

    function renderTipoFormulario(value) {
        switch (value) {
            case 0:
                return 'ORÇAMENTO DE SERVIÇOS'
            case 1:
                return 'ORÇAMENTO DE RECAPAGEM'
            case 2:
                return 'REMESSA'
            default:
                break;
        }
    }

    function handleDeleteFormulario(id_formulario) {
        Swal.fire({
            customClass: {
                container: swalstyles.swalcontainer,
                popup: swalstyles.swalbackground
            },
            title: 'DESEJA REALMENTE EXCLUIR O FORMULÁRIO?',
            text: 'ESTA AÇÃO É IRREVERSÍVEL!',
            confirmButtonText: 'CONFIRMAR',
            focusDeny: true,
            showDenyButton: true,
            denyButtonText: 'CANCELAR',
            allowOutsideClick: false,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                return api.put(`/formulario/deletarformulario`, {id_formulario_os_capa: id_formulario}).then(response => {
                    return response.data;
                }).catch(err => {
                    // handle error
                    console.log(err);
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'NÃO FOI POSSÍVEL CONCLUIR A REQUISIÇÃO!',
                        text: 'POR FAVOR, TENTE NOVAMENTE MAIS TARDE',
                        icon: 'error',
                    });
                });
            }
        }).then(result => {
            if(result.isConfirmed) {
                if(result.value.error) {
                    console.log(result.value.error);
                    Swal.fire({
                        customClass: {
                            container: swalstyles.swalcontainer,
                            popup: swalstyles.swalbackground
                        },
                        title: 'OCORREU UM ERRO INESPERADO!',
                        text: 'POR FAVOR, CONTATE UM ADMINISTRADOR DO SISTEMA',
                        icon: 'error',
                    });
                } else {
                    let newObj = Object.assign([], listFormularios);
                    let findedIndex = newObj.findIndex(({ id }) => id === id_formulario);

                    if(findedIndex !== -1) {
                        newObj.splice(findedIndex, 1);
                        setListFormularios(newObj);
                    }
                }
            }
        });
    }

    function renderDeleteFormulario(id_formulario, id_usuario) {
        if(id_usuario === parseInt(localStorage.usuario_id)) {
            return (
                <FaTrashAlt className={styleslistformularios.icondelete} onClick={() => handleDeleteFormulario(id_formulario)} />
            )
        }
    }

    function renderBodyListFormularios() {
        if(!loading && listFormularios.length) {
            return (
                listFormularios.map((formulario, index) => {
                    return (
                        <div className={[styleslistformularios.listformularios, styleslistformularios.listformulariosbody].join(' ')} key={index}>
                            <div className={[styleslistformularios.conteinerlistformularios, styleslistformularios.conteinerbodylistformularios].join(' ')}
                                onClick={() => history.push('/formularioos', {hasAccess: true, id_formulario_os_capa: formulario.id})}
                            >
                                <div>{formulario.id.toString().padStart(6, '0')}</div>
                                <div className={styleslistformularios.textleft} data-value={renderTipoFormulario(formulario.tipo)}>{renderTipoFormulario(formulario.tipo)}</div>
                                <div>{moment(formulario.data_hora_digitacao, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')}</div>
                                <div className={styleslistformularios.textleft} data-value={formulario.usuario}>{formulario.usuario}</div>
                                <div className={styleslistformularios.textleft}
                                    data-value={`${formulario.destinatario.codigo} - ${formulario.destinatario.descricao}${formulario.destinatario.cnpj ? ` (${maskCpfCnpj(formulario.destinatario.cnpj)})` : ''}`}
                                >
                                    {formulario.destinatario.codigo} - {formulario.destinatario.descricao}{formulario.destinatario.cnpj ? ` (${maskCpfCnpj(formulario.destinatario.cnpj)})` : ''}
                                </div>
                                <div>{formulario.os.codigo ? `${formulario.os.codigo}/${formulario.os.frota.codigo}` : '-'}</div>
                            </div>
                            <div className={styleslistformularios.conteinericondelete}>
                                {renderDeleteFormulario(formulario.id, formulario.id_usuario)}
                            </div>
                        </div>
                    )
                })
            )
        } else if(!loading && !listFormularios.length) {
            return (
                <div className={styleslistformularios.conteineremptylist}>
                    Nenhum documento foi encontrado!
                </div>
            )
        }
    }

    function renderListFormularios() {
        return (
            <>
                <div className={styleslistformularios.conteinerlist}>
                    <div className={[styleslistformularios.listformularios, styleslistformularios.listformularioshead].join(' ')}>
                        <div className={[styleslistformularios.conteinerlistformularios, styleslistformularios.conteinerheadlistformularios].join(' ')}>
                            <div>NÚM. DOC.</div>
                            <div>TIPO</div>
                            <div>DATA DOC.</div>
                            <div>USUÁRIO DIGITAÇÃO</div>
                            <div>EMPRESA DESTINATÁRIO</div>
                            <div>OS/FROTA</div>
                        </div>
                        <div className={styleslistformularios.conteinericondelete}></div>
                    </div>
                    {renderBodyListFormularios()}
                </div>
            </>
        )
    }

    function renderLoading() {
        if(loading) {
            return (
                <div className={[swalstyles.conteiner, swalstyles.conteinerloading].join(' ')}>
                    <div className={loadingstyles.divloading}>
                        <div className={loadingstyles.loading}></div>
                    </div>
                </div>
            )
        }
    }

    return (
        <>
            {renderLoading()}
            <div className="container-lg">
                <Header title="FORMULÁRIO DE ORÇAMENTO" />
                {renderListFormularios()}
            </div>
        </>
    )
}